import { render, staticRenderFns } from "./MonthlyWorkplaceReport.vue?vue&type=template&id=2b8412a2&"
import script from "./MonthlyWorkplaceReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyWorkplaceReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyWorkplaceReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports